import { render, staticRenderFns } from "./AdditionalSteps.vue?vue&type=template&id=476ebc8e&scoped=true&"
import script from "./AdditionalSteps.vue?vue&type=script&lang=js&"
export * from "./AdditionalSteps.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalSteps.vue?vue&type=style&index=0&id=476ebc8e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476ebc8e",
  null
  
)

export default component.exports